import Input from 'components/Input'
import { InputFieldTypes } from 'components/Input/types'
import { AddSelectedFiltersFunctionType } from 'core/multiple-search/redux/types'
import React, { useEffect, useState } from 'react'
import { FieldDataType } from './field-component'

type DateInputWrapperProps = {
  id: string
  fieldData: FieldDataType
  addSelectedFilters: AddSelectedFiltersFunctionType
}

export default function DateInputWrapper({ id, fieldData, addSelectedFilters }: DateInputWrapperProps) {
  const initialDateValue = { start: '', end: '' }
  const [date, setDate] = useState(initialDateValue)

  useEffect(() => {
    if(date.start && date.end) {
      addSelectedFilters(id, date, fieldData.name)
    }
  }, [date.start, date.end])

  return (
    <Input
      type={InputFieldTypes.datePicker}
      value={{ 
        start: '',
        end: '',
      }}
      setValue={setDate}
      labelParams={{ 
        i18nTag: fieldData.dateKey || ''
       }}
    />
  )
}
